export default typeof window !== 'undefined' ? window : global;

export const getEnv = (key, serverKey = key) =>
  typeof window !== 'undefined'
    ? window.env[key]
    : process.env[serverKey] || process.env[key];
